import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../components/down_nav.css";

function Down_nav() {
  return (
    <nav
      style={{
        borderRadius: "40px",
        background:
          "linear-gradient(to bottom,#C4E1E6,#EEEEEE,#EEEEEE,#EEEEEE,#EEEEEE,#C4E1E6)",
      }}
      id="down_nav"
      className="navbar navbar-expand-lg navbar-light fixed-bottom"
    >
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav w-100 d-flex justify-content-evenly">
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://www.facebook.com/people/Envis-Iisc/pfbid086ivC7Hzp7o5UAvG2swmdQ2SAtMq327kFJDgNCkvCZyPRZi7VeJsdhzBaZf4WWLBl/"
              >
                <img
                  height={20}
                  width={20}
                  src="images/facebook.png
                "
                  alt=""
                />
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://www.youtube.com/channel/UCaiGqgAzgpGZRUpn8tthn_w"
              >
                <img
                  height={20}
                  width={20}
                  src="images/youtube.png
                "
                  alt=""
                />
              </Link>
            </li>
            <li className="nav-item">
              <a
                className="nav-link underline-hover"
                href="mailto:tvr@iisc.ac.in"
              >
                Email
              </a>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://wgbis.ces.iisc.ac.in/"
              >
                Sahyadri
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://wgbis.ces.iisc.ac.in/biodiversity/"
              >
                Envis
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://wgbis.ces.iisc.ac.in/cesgrass/"
              >
                Grass
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://wgbis.ces.iisc.ac.in/energy/"
              >
                Energy
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://ces.iisc.ac.in/"
              >
                CES
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://cst.iisc.ac.in/cst/"
              >
                CST
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://cistup.iisc.ac.in/"
              >
                CiSTUP
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://iisc.ac.in/"
              >
                IISc
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://www.researchgate.net/publication/318983032_ENVironmental_Information_SystemENVIS"
              >
                <img
                  height={20}
                  width={20}
                  src="images/research_gate.png
                "
                  alt=""
                />
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link underline-hover"
                to="https://x.com/EnvisIisc?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              >
                <img
                  height={20}
                  width={20}
                  src="images/twitter.png
                "
                  alt=""
                />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Down_nav;
